import MixpanelEventBuilder from './MixpanelEventBuilder';
import RapidSearch, { ADVANCED_FILTER_FIELD_NAMES } from '../../constants/rapidSearch';
import Segment from '../../constants/segment';
import { RAPID_PROPERTY_TYPE_V2 } from '../Localization';

const PROPERTIES = {
    type: {
        label: 'Property Type',
        construct: MixpanelEventBuilder.propertyType,
    },
    holdPeriodUnit: {
        label: ['Hold Period Unit Min', 'Hold Period Unit Max'],
        construct: MixpanelEventBuilder.logFalseAsDefaultRangeHoldPeriod,
    },
    holdPeriodHouse: {
        label: [
            `Hold Period ${RAPID_PROPERTY_TYPE_V2[0].label} Min`,
            `Hold Period ${RAPID_PROPERTY_TYPE_V2[0].label} Max`,
        ],
        construct: MixpanelEventBuilder.logFalseAsDefaultRangeHoldPeriod,
    },
    beds: {
        label: ['Bed Min', 'Bed Max'],
        construct: MixpanelEventBuilder.logFalseAsDefaultRange,
    },
    carSpaces: {
        label: ['Car Min', 'Car Max'],
        construct: MixpanelEventBuilder.logFalseAsDefaultRange,
    },
    baths: {
        label: ['Bath Min', 'Bath Max'],
        construct: MixpanelEventBuilder.logFalseAsDefaultRange,
    },
    landArea: MixpanelEventBuilder
        .constructMixpanelEventBuilderAreaProperties([
            'Land Size Min', 'Land Size Max', 'Land Size Unit'
        ]),
    salesLastSoldPrice: {
        label: ['Sale Price Min', 'Sale Price Max'],
        construct: MixpanelEventBuilder.landSizeAndPricesProperties,
    },
    salesLastSaleContractDate: {
        label: ['Sale Date Min', 'Sale Date Max'],
        construct: MixpanelEventBuilder.dateFilterProperties,
    },
    salesLastCampaignLastListedPrice: {
        label: ['Listing Price Min', 'Listing Price Max'],
        construct: MixpanelEventBuilder.landSizeAndPricesProperties,
    },
    salesLastSaleSettlementDate: {
        label: ['Settlement Date Min', 'Settlement Date Max'],
        construct: MixpanelEventBuilder.dateFilterProperties,
    },
    salesLastCampaignStartDate: {
        label: ['First Listing Date Min', 'First Listing Date Max'],
        construct: MixpanelEventBuilder.dateFilterProperties,
    },
    salesLastCampaignDaysOnMarket: {
        label: 'Days on Market',
        construct: MixpanelEventBuilder.domFilterProperties,
    },
    salesLastCampaignEndDate: {
        label: ['Listing Date Min', 'Listing Date Max'],
        construct: MixpanelEventBuilder.dateFilterProperties,
    },
    rentalLastCampaignLastListedPrice: {
        label: ['Rental Price Min', 'Rental Price Max'],
        construct: MixpanelEventBuilder.landSizeAndPricesProperties,
    },
    rentalLastCampaignEndDate: {
        label: ['Rental Date Min', 'Rental Date Max'],
        construct: MixpanelEventBuilder.dateFilterProperties,
    },
    rentalLastCampaignStartDate: {
        label: ['First Rental Date Min', 'First Rental Date Max'],
        construct: MixpanelEventBuilder.dateFilterProperties,
    },
    rentalLastCampaignLastListedPeriod: {
        label: 'Rental Period',
        construct: (eventPropsLabel, filterValue, eventProps) =>
            MixpanelEventBuilder.withDefaultProperties(
                eventPropsLabel, RapidSearch.FILTER_PERIOD_OPTIONS[filterValue].label,
                eventProps, RapidSearch.FILTER_PERIOD_OPTIONS[RapidSearch.WEEKLY].label,
            ),
    },
    valuationCapitalValue: {
        label: ['Capital Value Min', 'Capital Value Max'],
        construct: MixpanelEventBuilder.landSizeAndPricesProperties,
    },
    valuationAssessmentDate: {
        label: ['Valuation Date Min', 'Valuation Date Max'],
        construct: MixpanelEventBuilder.dateFilterProperties,
    },
    yearBuilt: {
        label: ['Year Built Min', 'Year Built Max'],
        construct: MixpanelEventBuilder.logFalseAsDefaultRange,
    },
    salesClassification: MixpanelEventBuilder
        .constructMixpanelEventBuilderTextFieldProperties(ADVANCED_FILTER_FIELD_NAMES.salesClassification),
    salesLastCampaignListedType: {
        label: 'Listing Type',
        construct: MixpanelEventBuilder.listingType,
    },
    subType: {
        label: 'Property Sub Type',
        construct: MixpanelEventBuilder.multiSelectionFilterProperties,
    },
    keywords: {
        label: 'Keyword Search',
        construct: MixpanelEventBuilder.propertiesForArrayValues,
    },
    developmentZoneDescription: {
        label: 'Development Zone',
        construct: MixpanelEventBuilder.multiSelectionFilterProperties,
    },
    landUse: {
        label: 'Land Use',
        construct: MixpanelEventBuilder.multiSelectionFilterProperties,
    },
    suburbOnly: {
        label: 'Target Suburb',
        construct: MixpanelEventBuilder.logFalseAsDefaultNotRange,
    },
    radius: {
        label: 'Distance',
        construct: (eventPropsLabel, filterValue, eventProps) => {
            MixpanelEventBuilder.logFalseAsDefaultNotRange(
                eventPropsLabel,
                filterValue, eventProps,
            );
            eventProps.push({
                label: Segment.EVENT_PROPERTIES.SEARCH_TYPE,
                value: Segment.EVENT_PROPERTIES.RADIUS,
            });
        },
    },
    rentalOccupancy: {
        label: 'Exclude Likely Rental',
        construct: MixpanelEventBuilder.logOnTrueFalseValue,
    },
    salesLastSaleSource: {
        label: 'Exclude AA',
        construct: MixpanelEventBuilder.logOnTrueFalseValue,
    },
    salesLastSaleIsArmsLength: {
        label: 'Exclude Related Parties',
        construct: MixpanelEventBuilder.logOnTrueFalseValue,
    },
    feeCode: {
        label: 'Fee Code',
        construct: MixpanelEventBuilder.withDefaultProperties,
    },

    distanceToHospital: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Distance to Hospital Min', 'Distance to Hospital Max'
        ]),

    distanceToRiverFrontage: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Distance to River Frontage Min', 'Distance to River Frontage Max'
        ]),

    distanceToSchool: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Distance to School Min', 'Distance to School Max'
        ]),

    distanceToShops: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Distance to Shop Min', 'Distance to Shop Max'
        ]),

    distanceToSeaRiverCanal: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Distance to Sea River Canal Min', 'Distance to Sea River Canal Max'
        ]),

    allWeatherAccessToLand: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.allWeatherAccessToLand),

    allWeatherRoadsToFarm: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.allWeatherRoadsToFarm),

    housesOnFarm: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Houses on Farm Min', 'Houses on Farm Max'
        ]),

    irrigatedArea: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Irrigated Area Min', 'Irrigated Area Max'
        ]),

    damsBores: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'No. of Dams/Bores Min', 'No. of Dams/Bores Max'
        ]),

    paddocksYards: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Number of Paddocks/Yards Min', 'Number of Paddocks/Yards Max'
        ]),

    permanentWater: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.permanentWater),

    sealedRoadsToProperty: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.sealedRoadsToProperty),

    accessAvailable24Hrs: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.accessAvailable24Hrs),

    accessSecurityInstalled: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.accessSecurityInstalled),

    closeToPublicTransport: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.closeToPublicTransport),

    liftInstalled: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.liftInstalled),

    onMainRoad: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.onMainRoad),

    sewage: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.sewage),

    townSewerageAvailable: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.townSewerageAvailable),

    townWaterAvailable: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.townWaterAvailable),

    water: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.water),

    canalFrontage:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.canalFrontage),

    coastFrontage:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.coastFrontage),

    golfFrontage:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.golfFrontage),

    highExposure:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.highExposure),

    lakeFrontage:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.lakeFrontage),

    riverFrontage:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.riverFrontage),

    scenicView:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.scenicView),

    waterFrontage:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.waterFrontage),

    latestConsumerSaleEstimate: {
        label: [`${ADVANCED_FILTER_FIELD_NAMES.latestConsumerSaleEstimate} Min`, `${ADVANCED_FILTER_FIELD_NAMES.latestConsumerSaleEstimate} Max`],
        construct: MixpanelEventBuilder.landSizeAndPricesProperties,
    },

    latestConsumerSaleConfidence: {
        label: 'Valuation Estimate Confidence',
        construct: MixpanelEventBuilder.valuationConfidenceFilterProperties,
    },

    currentUnimprovedLandValue: {
        label: [`${ADVANCED_FILTER_FIELD_NAMES.currentUnimprovedLandValue} Min`, `${ADVANCED_FILTER_FIELD_NAMES.currentUnimprovedLandValue} Max`],
        construct: MixpanelEventBuilder.landSizeAndPricesProperties,
    },

    unimprovedCapitalValue: {
        label: [`${ADVANCED_FILTER_FIELD_NAMES.unimprovedCapitalValue} Min`, `${ADVANCED_FILTER_FIELD_NAMES.unimprovedCapitalValue} Max`],
        construct: MixpanelEventBuilder.landSizeAndPricesProperties,
    },

    unimprovedCapitalValueDate: {
        label: [`${ADVANCED_FILTER_FIELD_NAMES.unimprovedCapitalValueDate} Min`, `${ADVANCED_FILTER_FIELD_NAMES.unimprovedCapitalValueDate} Max`],
        construct: MixpanelEventBuilder.dateFilterProperties,
    },

    valuationLandValue: {
        label: [`${ADVANCED_FILTER_FIELD_NAMES.valuationLandValue} Min`, `${ADVANCED_FILTER_FIELD_NAMES.valuationLandValue} Max`],
        construct: MixpanelEventBuilder.landSizeAndPricesProperties,
    },

    valuationImprovementsValue: {
        label: [`${ADVANCED_FILTER_FIELD_NAMES.valuationImprovementsValue} Min`, `${ADVANCED_FILTER_FIELD_NAMES.valuationImprovementsValue} Max`],
        construct: MixpanelEventBuilder.landSizeAndPricesProperties,
    },


    boatRampMooringSpace:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.boatRampMooringSpace),

    fenced:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.fenced),

    grannyFlatSelfContained:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.grannyFlatSelfContained),

    swimmingPool:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.swimmingPool),

    treesOnLand:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.treesOnLand),

    lockupGarages:  {
        label: ['Lockup Garages Min', 'Lockup Garages Max'],
        construct: MixpanelEventBuilder.logFalseAsDefaultRange,
    },

    noOfTennisCourts:  {
        label: ['Tennis Courts Min', 'Tennis Courts Max'],
        construct: MixpanelEventBuilder.logFalseAsDefaultRange,
    },

    materialsInExternalWalls:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.materialsInExternalWalls),

    wallMaterial:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.wallMaterial),

    materialsInRoof:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.materialsInRoof),

    roofMaterial:  MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.roofMaterial),

    factoryArea: MixpanelEventBuilder
        .constructMixpanelEventBuilderAreaProperties([
            'M2 of factory space Min', 'M2 of factory space Max', 'M2 of factory space Unit'
        ]),
    mezzanineArea: MixpanelEventBuilder
        .constructMixpanelEventBuilderAreaProperties([
            'M2 of mezzanine space Min', 'M2 of mezzanine space Max', 'M2 of mezzanine space Unit'
        ]),
    officeShowroomArea: MixpanelEventBuilder
        .constructMixpanelEventBuilderAreaProperties([
            'M2 of office/showroom space Min', 'M2 of office/showroom space Max', 'M2 of office/showroom space Unit'
        ]),
    otherArea: MixpanelEventBuilder
        .constructMixpanelEventBuilderAreaProperties([
            'M2 of other space Min', 'M2 of other space Max', 'M2 of other space Unit'
        ]),
    shopArea: MixpanelEventBuilder
        .constructMixpanelEventBuilderAreaProperties([
            'M2 of shop space Min', 'M2 of shop space Max', 'M2 of shop space Unit'
        ]),
    showroomArea: MixpanelEventBuilder
        .constructMixpanelEventBuilderAreaProperties([
            'M2 of showroom space Min', 'M2 of showroom space Max', 'M2 of showroom space Unit'
        ]),
    warehouseArea: MixpanelEventBuilder
        .constructMixpanelEventBuilderAreaProperties([
            'M2 of warehouse space Min', 'M2 of warehouse space Max', 'M2 of warehouse space Unit'
        ]),
    workshopArea: MixpanelEventBuilder
        .constructMixpanelEventBuilderAreaProperties([
            'M2 of workshop space Min', 'M2 of workshop space Max', 'M2 of workshop space Unit'
        ]),
    airConditioned: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.airConditioned),

    builtInWardrobes: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.builtInWardrobes),

    ductedHeating: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.ductedHeating),

    ductedVacuum: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.ductedVacuum),

    fireplace: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.fireplace),

    openPlan: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.openPlan),

    polishedFloors: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.polishedFloors),

    renovated: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.renovated),

    diningRooms: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Dining Rooms Min', 'Dining Rooms Max'
        ]),

    familyRumpusRooms: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Family/Rumpus Rooms Min', 'Family/Rumpus Rooms Max'
        ]),

    floorLevelsInside: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Floor levels Inside Min', 'Floor levels Inside Max'
        ]),

    loungeRooms: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Lounge Rooms Min', 'Lounge Rooms Max'
        ]),

    loungeDiningRoomsCombined: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Lounge/Dining Rooms Combined Min', 'Lounge/Dining Rooms Combined Max'
        ]),

    kitchens: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Kitchens Min', 'Kitchens Max'
       ]),

    noOfStudyRooms: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'No. of Study Min', 'No. of Study Max'
        ]),

    toilets: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Toilets Min', 'Toilets Max'
        ]),

    heritageOtherClassification: MixpanelEventBuilder
        .constructMixpanelEventBuilderTextFieldProperties(ADVANCED_FILTER_FIELD_NAMES.heritageOtherClassification),

    buildingArea: MixpanelEventBuilder
        .constructMixpanelEventBuilderAreaProperties([
            'Building Area Min', 'Building Area Max', 'Building Area Unit'
        ]),

    equivalentBuildingArea: MixpanelEventBuilder
        .constructMixpanelEventBuilderAreaProperties([
            'Equivalent Building Area Min', 'Equivalent Building Area Max', 'Equivalent Building Area Unit'
        ]),

    floorLevelOfUnit: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Floor level of Unit Min', 'Floor level of Unit Max'
        ]),

    floorArea: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            `${ADVANCED_FILTER_FIELD_NAMES.floorArea} Min`, `${ADVANCED_FILTER_FIELD_NAMES.floorArea} Max`
        ]),

    floorLevelsInsideUnit: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'No. Floor Levels inside Unit Min', 'No. Floor Levels inside Unit Max'
        ]),

    flats: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Number of Flats Min', 'Number of Flats Max'
        ]),

    streetFrontage: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Street Frontage (m) Min', 'Street Frontage (m) Max'
        ]),

    totalFloorsInBuilding: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Total floors in Building Min', 'Total floors in Building Max'
        ]),

    yearBuildingRefurbished: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Year Building Refurbished Min', 'Year Building Refurbished Max'
        ]),

    yearEstablished: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultRange([
            'Year Established Min', 'Year Established Max'
        ]),
    freeStandingBuilding: MixpanelEventBuilder
        .constructMixpanelEventBuilderLogFalseAsDefaultNotRange(ADVANCED_FILTER_FIELD_NAMES.freeStandingBuilding),
    isActiveForSaleCampaign: {
        label: 'Show Active Listings',
        construct: MixpanelEventBuilder.logFalseAsDefaultNotRange,
    },
    isActiveForRentCampaign: {
        label: 'Show Active Listings',
        construct: MixpanelEventBuilder.logFalseAsDefaultNotRange,
    },
};

const TABS_ATTR = {
    all: 'Property',
    recentSale: 'Sales History',
    forSale: 'On The Market',
    forRent: 'Rentals',
    aged: 'Aged Listings',
    withdrawn: 'Withdrawn Listings',
    tenure: 'Tenure',
};

const DEFAULT_PROPERTIES = {
    all: [{ name: 'type', defaultValue: 'All' }, ],
    recentSale: [
        { name: 'type', defaultValue: 'All' },
        { name: 'salesLastSaleSource', defaultValue: false },
        { name: 'salesClassification', defaultValue: false, country: 'nz' },
        { name: 'salesLastSaleSettlementDate', defaultValue: false },
        { name: 'salesLastSaleIsArmsLength', defaultValue: false },
    ],
    forSale: [
        { name: 'type', defaultValue: 'All' }, { name: 'salesLastCampaignListedType', defaultValue: '' },
        { name: 'isActiveForSaleCampaign', defaultValue: false },
    ],
    forRent: [{ name: 'type', defaultValue: 'All' }, { name: 'isActiveForRentCampaign', defaultValue: false }],
    aged: [{ name: 'type', defaultValue: 'All' }, { name: 'isActiveForSaleCampaign', defaultValue: false }],
    withdrawn: [{ name: 'type', defaultValue: 'All' }],
    tenure: [{ name: 'type', defaultValue: 'All' }],
};

export default {
    PROPERTIES,
    TABS_ATTR,
    DEFAULT_PROPERTIES,
};
